import React, { useState, useRef, useContext } from "react";
import { usePopupClickOutside } from "../../../hooks/usePopupClickOutside";
import CreateDropdownMenu from "./CreateDropdownMenu";
const arrowDownIcon = require("../styles/images/white-down-arrow.svg");
import { PhotoManagerContext } from "./index";

interface CreateDropdownProps {
  onGalleryClick: () => void;
  onFolderClick: () => void;
  canCreateEvents?: boolean;
  canCreateFolders?: boolean;
}

const CreateDropdown: React.FC<CreateDropdownProps> = ({
  onGalleryClick,
  onFolderClick,
  canCreateEvents = true,
  canCreateFolders = true
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const context = useContext(PhotoManagerContext);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const closeDropdown = () => {
    setIsOpen(false);
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const handleFolderCreate = () => {
    if (!context) return;

    const isInFolder =
      context.selectedFolderId !== null &&
      context.selectedFolderId !== undefined;
    const folderType = isInFolder ? "sub-folder" : "library-folder";

    context.openCreateModal();
    context.setCreateFolderType(folderType);

    onFolderClick();
  };
  const handleGalleryClick = () => {
    if (!context) return;

    if (!context.simpleEventCreationEnabled) {
      const params = new URLSearchParams();
      if (context.selectedFolderId) {
        params.append("library_folder_id", context.selectedFolderId.toString());
      }
      window.location.href = `/dashboard/events/new/our?${params}`;
    } else {
      context.openCreateEventModal();
    }

    closeDropdown();
    onGalleryClick();
  };

  usePopupClickOutside(dropdownRef, closeDropdown);

  // Hide entire dropdown if user can't create anything
  if (!canCreateEvents && !canCreateFolders) {
    return null;
  }

  return (
    <div className="dropdown" ref={dropdownRef}>
      <button
        type="button"
        className="geo-btn geo-btn--small geo-btn--secondary geo-btn--caps dropdown-toggle create-dd-btn"
        onClick={toggleDropdown}
        aria-haspopup="true"
        aria-expanded={isOpen}
      >
        Create{" "}
        <img
          id="ws-arrow-down-icon"
          src={arrowDownIcon}
          alt="Uploader-options"
        />
      </button>

      {isOpen && (
        <CreateDropdownMenu
          onGalleryClick={() => handleGalleryClick()}
          onFolderClick={handleFolderCreate}
          canCreateEvents={canCreateEvents}
          canCreateFolders={canCreateFolders}
        />
      )}
    </div>
  );
};

export default CreateDropdown;
